import { FC, useMemo } from 'react';
import NotAvailable from 'src/assets/img/not-available.png';
import { InvoiceDetailsResponse } from 'src/services/useInvoiceDetailsApi';
import { IReceipt as ReceiptDetailsResponse } from 'src/types/Receipt';
import { validSignedUrl } from 'src/utils/strings';
import { useContextSelector } from 'use-context-selector';
import { InvoiceContext } from './InvoiceDetailsContext';
import OcrInvoice from './OcrInvoice';

interface OcrScanPreviewProps {
  document: ReceiptDetailsResponse | InvoiceDetailsResponse;
  isLoading: boolean;
}

const OcrScanPreview: FC<OcrScanPreviewProps> = ({ document, isLoading }) => {
  const ocrResponse = useContextSelector(InvoiceContext, (value) => value.ocrResponse);
  const initialInvoice = useContextSelector(InvoiceContext, (value) => value.initialInvoice);

  const attachmentCount = document?.attachments.length;
  const attachment = document?.attachments[0];
  const isPDF = useMemo(
    () => attachment?.description?.toLowerCase().endsWith('.pdf'),
    [attachment]
  );
  const url = useMemo(() => `${validSignedUrl(attachment?.signedUrl)}`, [attachment?.signedUrl]);

  return (
    <>
      {isLoading ? (
        <div className="w-full h-24 flex items-center justify-center">
          <span className="k-icon k-i-loading text-xl" />
        </div>
      ) : (
        <>
          <div className="flex flex-row items-center p-2 gap-2 justify-center">
            Document {attachmentCount > 0 ? 1 : 0} of {attachmentCount}
          </div>
          {attachment && (
            <OcrInvoice
              src={url}
              isPDF={isPDF}
              fileName={attachment.originalFile}
              data={ocrResponse}
              invoiceOcrConfidence={initialInvoice.ocrConfidencePercentage}
            />
          )}
          {!attachment && (
            <img src={NotAvailable} alt="Not Available" className="mx-auto mt-4 block" />
          )}
        </>
      )}
    </>
  );
};

export default OcrScanPreview;
